// import { useState, useMemo } from "react";
import { Spin, Alert, Empty, Button } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import NarinLayout from "components/NarinLayout";
import { useGetRedemptionCatalog } from "services/redemption";
// import { RedemptionItemType } from "types/redemption";
import useUserStore from "stores/user";
import useLoginModal from "hooks/useLoginModal";
import StarIcon from "icons/StarIcon";
import RedemptionItemCard from "./components/RedemptionItemCard";
import PointsBalance from "./components/PointsBalance";
import { useNavigate } from "react-router-dom";

const RedemptionPage = () => {
  const { user } = useUserStore();
  const { loginModal, showLogin } = useLoginModal();
  const navigate = useNavigate();

  // Filter and search states
  // const [searchTerm, setSearchTerm] = useState("");
  // const [selectedType, setSelectedType] = useState<RedemptionItemType | "ALL">(
  //   "ALL"
  // );
  // const [sortBy, setSortBy] = useState<
  //   "points_asc" | "points_desc" | "name_asc" | "name_desc"
  // >("points_asc");

  const {
    // catalogData,
    redemptionItems,
    userCapsulePoints,
    redemptionConfig,
    isLoading,
    error,
    refetch,
  } = useGetRedemptionCatalog(!!user);

  // Filter and sort redemption items
  // const filteredAndSortedItems = useMemo(() => {
  //   let filtered = redemptionItems;

  //   // Filter by search term
  //   if (searchTerm) {
  //     filtered = filtered.filter(
  //       (item) =>
  //         item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //         item.description?.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //   }

  //   // Filter by type
  //   if (selectedType !== "ALL") {
  //     filtered = filtered.filter((item) => item.type === selectedType);
  //   }

  //   // Sort items
  //   filtered.sort((a, b) => {
  //     switch (sortBy) {
  //       case "points_asc":
  //         return a.pointsCost - b.pointsCost;
  //       case "points_desc":
  //         return b.pointsCost - a.pointsCost;
  //       case "name_asc":
  //         return a.name.localeCompare(b.name);
  //       case "name_desc":
  //         return b.name.localeCompare(a.name);
  //       default:
  //         return 0;
  //     }
  //   });

  //   return filtered;
  // }, [redemptionItems, searchTerm, selectedType, sortBy]);

  // const handleClearFilters = () => {
  //   setSearchTerm("");
  //   setSelectedType("ALL");
  //   setSortBy("points_asc");
  // };

  const handleAddToCartSuccess = () => {
    // Optionally refetch catalog to update any stock limits
    refetch();
  };

  // Show login modal if user is not authenticated
  if (!user) {
    return (
      <NarinLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="text-center max-w-md mx-auto">
            <div className="bg-white rounded-2xl shadow-lg p-8 border">
              <div className="mb-6">
                <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <StarIcon className="text-primary-500 w-8 h-8" />
                </div>
                <h1 className="text-3xl font-bold mb-2 bg-gradient-to-r from-primary-500 to-primary-700 bg-clip-text text-transparent">
                  แลกคะแนน
                </h1>
                <p className="text-gray-600 mb-6">
                  Please log in to view available redemption items and start
                  earning rewards.
                </p>
              </div>
              <button
                onClick={showLogin}
                className="w-full bg-primary-500 text-white px-6 py-3 rounded-lg hover:bg-primary-600 transition-colors duration-200 font-medium"
              >
                เข้าสู่ระบบ / ลงทะเบียน
              </button>
            </div>
          </div>
          {loginModal}
        </div>
      </NarinLayout>
    );
  }

  if (isLoading) {
    return (
      <NarinLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <Spin size="large" />
            <p className="mt-4">กำลังโหลดสินค้าแลกคะแนน...</p>
          </div>
        </div>
      </NarinLayout>
    );
  }

  if (error) {
    return (
      <NarinLayout>
        <div className="container mx-auto px-4 py-8">
          <Alert
            message="Error Loading"
            description="Failed to load redemption catalog. Please try again later."
            type="error"
            showIcon
          />
        </div>
      </NarinLayout>
    );
  }

  return (
    <NarinLayout>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50">
        <div className="container mx-auto px-4 py-8">
          {/* Page Header */}
          <div className="mb-8 relative">
            <div className="absolute top-0 right-0">
              <Button
                type="default"
                icon={<HistoryOutlined />}
                onClick={() => navigate("/points-history")}
                className="shadow-sm hover:shadow-md transition-all duration-200"
              >
                ประวัติการเปลี่ยนแปลงคะแนน
              </Button>
            </div>

            <h1 className="text-xl font-bold mb-4 text-primary-700 ">
              แลกคะแนน
            </h1>
          </div>

          {/* Points Balance */}
          <div className="mb-8">
            <PointsBalance
              userCapsulePoints={userCapsulePoints}
              redemptionConfig={redemptionConfig}
            />
          </div>
          <div className="bg-white p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
              {redemptionItems.length > 0 ? (
                redemptionItems.map((item) => (
                  <div
                    key={item.id}
                    className="transform transition-all duration-200 hover:-translate-y-1"
                  >
                    <RedemptionItemCard
                      item={item}
                      userCapsulePoints={userCapsulePoints}
                      onAddToCartSuccess={handleAddToCartSuccess}
                    />
                  </div>
                ))
              ) : (
                <div className="col-span-full">
                  <div className="bg-white rounded-2xl shadow-sm p-12 text-center">
                    <Empty
                      description={
                        <div className="text-gray-500">
                          <div className="text-lg font-medium mb-2">
                            ไม่มีสินค้าแลกซื้อในขณะนี้
                          </div>
                          <div className="text-sm">
                            กรุณากลับมาตรวจสอบใหม่ภายหลัง
                          </div>
                        </div>
                      }
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </NarinLayout>
  );
};

export default RedemptionPage;
